import React, { useEffect, useState } from "react";
import { Route, Link } from "react-router-dom";

import { Title, useNotify } from "react-admin";

import {
  CircularProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  ListItemSecondaryAction,
  IconButton,
  Divider,
  FormControl,
  FormControlLabel,
  Switch,
  Typography,
  Grid,
  Box,
  Backdrop,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import XIcon from "@material-ui/icons/CloseOutlined";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import InbounddOutlinedIcon from "@material-ui/icons/FastForwardOutlined";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import PendingApprovalIcon from "@material-ui/icons/PriorityHigh";
import RefreshIcon from "@material-ui/icons/Refresh";
import ReviewOutlinedIcon from "@material-ui/icons/FindInPageOutlined";
import { makeStyles } from "@material-ui/core/styles";
import { orange, amber, grey, green, red } from "@material-ui/core/colors";
import { useMediaQuery } from "@material-ui/core";
import { ProcessInboundShipmentCard } from "./ProcessShipmentsCard";
import { InboundProvider, useInboundContext } from "./context";

import { CarrierType, InboundState } from "../../../utils/constants";
import useStickyState from "../../../utils/stickyState";
import { logError } from "../../../utils/appUtils";

import CrewCard from "../../../components/common/CrewCard";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { accountNameRenderer } from "../../../components/common/AccountNameRenderer";

const useStyles = makeStyles((theme) => ({
  actions: {
    display: "flex",
    justifyContent: "flex-start",
  },
  progress: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 300,
  },
  orange: {
    color: theme.palette.getContrastText(orange[100]),
    backgroundColor: orange[100],
  },
  green: {
    color: theme.palette.getContrastText(green[200]),
    backgroundColor: green[200],
  },
  red: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
  },
  amber: {
    color: theme.palette.getContrastText(amber[500]),
    backgroundColor: amber[500],
  },
  unprocessedItem: {
    color: theme.palette.getContrastText(grey[300]),
    backgroundColor: grey[300],
  },
  backToInventory: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(4),
  },
  inventoriesSection: {
    marginTop: theme.spacing(2),
  },
  link: {
    color: "inherit",
    textDecoration: "inherit",
  },
  photoErrorSection: {
    paddingLeft: theme.spacing(2),
  },
  notFound: {
    display: "fles",
    margin: theme.spacing(2),
  },
  topActions: {
    paddingTop: theme.spacing(1.5),
    display: "flex",
    alignItems: "flex-end",
  },
  exceptionContainer: {
    marginBottom: theme.spacing(2),
  },
  backdrop: {
    zIndex: 90001,
  },
  searchField: {
    marginLeft: theme.spacing(1),
  },
  speedDial: {
    position: "fixed",
    bottom: theme.spacing(4),
    right: theme.spacing(4),
  },
  speedDialAction: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    backgroundColor: orange[400],
    "&:hover": {
      backgroundColor: orange[400],
    },
  },
}));

export const ProcessShipments = (props) => {
  const classes = useStyles();

  return (
    <InboundProvider>
      <Title title={<ForceTitle title="Inbounds" />} />
      <Route
        path={`${props.match.path}`}
        exact
        render={(props) => <PlacedShipmentList classes={classes} {...props} />}
      />
      <Route
        path={`${props.match.path}/:id`}
        render={(props) => (
          <ProcessInboundShipmentCard classes={classes} {...props} />
        )}
      />
    </InboundProvider>
  );
};

const PlacedShipmentList = (props) => {
  const notify = useNotify();
  const { state, dispatch, getShipments } = useInboundContext();
  const { loading } = state;
  const [term, setTerm] = useState("");
  const { classes, match } = props;
  const { placedShipments } = state;
  const [searchShipments, setSearchShipments] = useState([]);
  const [showAccepted, setShowAccepted] = useStickyState(false, "showAccepted");
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  useEffect(() => {
    init();
    return () => {
      dispatch({ type: "CLEAR_SHIPMENTS" });
      debugger;
    };
  }, []);

  const init = async () => {
    debugger;
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      const data = await getShipments();
      setSearchShipments(data);
      dispatch({
        type: "PLACED_SHIPPMENTS_LOADED",
        payload: data,
      });
    } catch (err) {
      logError("ProcessShipments:init", err, notify);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const getShipmentSecondaryText = (shipment, isSmall) => {
    const carLabel =
      shipment.carrierType === CarrierType.RAIL ? "Car No: " : "Trl No: ";
    if (isSmall) return shipment.railCarNumber;
    else
      return (
        carLabel + shipment.railCarNumber + " - PO No: " + shipment.poNumber
      );
  };

  const getIcon = (shipment) => {
    if (shipment.state === InboundState.PROCESS_INVENTORY)
      return <CheckIcon fontSize="inherit" />;
    else if (shipment.state === InboundState.PROCESS_INVENTORY_REVIEW)
      return <ReviewOutlinedIcon fontSize="inherit" />;
    else if (shipment.verificationRequired === "true")
      return <PendingApprovalIcon fontSize="inherit" />;
    return <CloseOutlinedIcon fontSize="inherit" />;
  };

  const getAvatarClassName = (shipment) => {
    if (
      shipment.verificationRequired === "true" ||
      shipment.verificationRequired === "resolved"
    ) {
      return classes.amber;
    } else if (shipment.state === InboundState.PROCESS_INVENTORY) {
      return classes.green;
    }
    return classes.unprocessedItem;
  };

  const handleSelect = (shipment) => {
    dispatch({ type: "SET_CURRENT_SHIPPMENT", payload: shipment });
  };

  const toggleChecked = () => {
    setShowAccepted(!showAccepted);
    showAcceptedShipment(!showAccepted);
  };

  const refresh = () => {
    init();
  };

  const showAcceptedShipment = (showAccepted) => {
    const acceptedShippments = showAccepted
      ? searchShipments.filter((itm) => {
        return itm.state === InboundState.PROCESS_INVENTORY;
      })
      : [...searchShipments];
    return acceptedShippments;
  };

  const handleSearch = (evt) => {
    debugger;
    const value = evt.target.value;
    setTerm(value);
    let searchResult = placedShipments;
    if (value) {
      const searchTerm = value.toLowerCase();
      searchResult = placedShipments.filter((itm) => {
        if (
          itm.accountName.toLowerCase().includes(searchTerm) ||
          itm.railCarNumber.toLowerCase().includes(searchTerm) ||
          itm.lotNumber?.toLowerCase().includes(searchTerm) ||
          itm.poNumber?.toLowerCase().includes(searchTerm)
        ) {
          return true;
        }
        return false;
      });
    }
    setSearchShipments(searchResult);
  };

  const handleSubmit = (evt) => {
    if (evt.key === "Enter") {
      handleSearch(evt);
    }
  };

  const clear = () => {
    setTerm("");
    setSearchShipments(placedShipments);
  };

  const visibleShipments = showAcceptedShipment(showAccepted, searchShipments);

  return (
    <CrewCard
      title={isSmall ? "Inbound" : "Inbound Shipments"}
      icon={<InbounddOutlinedIcon fontSize="large" />}
      action={
        <div className={classes.topActions}>
          <IconButton onClick={refresh}>
            <RefreshIcon fontSize="large" />
          </IconButton>
        </div>
      }
    >
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            id="search"
            name="search"
            size="small"
            variant="outlined"
            margin="dense"
            onChange={handleSearch}
            value={term}
            placeholder="Search"
            className={classes.searchField}
            onKeyDown={handleSubmit}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton disableRipple onClick={clear}>
                    <XIcon className={classes.clearButton} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            pl={isSmall ? 1.5 : 0}
            pt={0.5}
            display="flex"
            justifyContent={isSmall ? "flex-start" : "flex-end"}
          >
            <FormControl>
              <FormControlLabel
                label="Accepted shipments"
                labelPlacement="end"
                control={
                  <Switch
                    color={showAccepted ? "secondary" : "default"}
                    checked={showAccepted}
                    onChange={toggleChecked}
                  />
                }
              />
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <List>
            {visibleShipments ? (
              visibleShipments.map((shipment, idx) => {
                return (
                  <Link
                    className={classes.link}
                    to={match.path + "/" + shipment.id}
                    key={shipment.id}
                  >
                    <ListItem onClick={() => handleSelect(shipment)}>
                      <ListItemAvatar>
                        <Avatar className={getAvatarClassName(shipment)}>
                          {getIcon(shipment)}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Typography>
                            {accountNameRenderer(shipment)}
                          </Typography>
                        }
                        secondary={
                          <>
                            <Typography
                              variant="subtitle2"
                              color="textSecondary"
                            >
                              {getShipmentSecondaryText(shipment, isSmall)}
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              color="textSecondary"
                            >
                              {shipment.assignedTo}
                            </Typography>
                          </>
                        }
                      />
                      <ListItemSecondaryAction>
                        <IconButton
                          edge="end"
                          onClick={() => handleSelect(shipment)}
                        >
                          <KeyboardArrowRightIcon fontSize="large" />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    {idx < searchShipments.length - 1 ? <Divider /> : null}
                  </Link>
                );
              })
            ) : (
              <Typography className={classes.notFound}>
                No shipments found.
              </Typography>
            )}
          </List>
        </Grid>
      </Grid>
    </CrewCard>
  );
};
